import procTitle from './proc-01-title.js';
import procStack from './proc-02-stack.js';
import procShuffle from './proc-03-shuffle.js';
import procLine from './proc-04-line.js';
import procSelect from './proc-05-select.js';
import procOpen from './proc-06-open.js';
import procResult from './proc-07-result.js';

export async function start(params) {
    await procTitle(params);
    await procStack(params);
    await procShuffle(params);
    await procLine(params);
    await procSelect(params);
    await procOpen(params);
    await procResult(params);
}
